type MVP = {
  title: string;
  text: string;
};

export interface MissionVisionPurposeCIIONProps {
  id?: string;
  title?: string;
  mission?: MVP;
  vision?: MVP;
  purpose?: MVP;
}

export const defaultProps = {
  title: "Mission, Vision, and Purpose",
  mission: {
    title: "Our Mission",
    text: "Empowering the next generation of nursing assistants with digital mastery and hands-on expertise for compassionate healthcare. Our mission is to cultivate a community of passionate lifelong learners who are dedicated to making a difference in the world.",
  },
  vision: {
    title: "Our Vision",
    text: "Empowering healthcare leaders. We believe that education is more than a stepping stone to a career, it's a lifelong pursuit. We provide students with the tools and knowledge needed to become leaders in their field.",
  },
  purpose: {
    title: "Our Purpose",
    text: "At Care Indeed Institute of Nursing, we firmly believe that compassion combined with excellence can reshape healthcare. We see immense potential in you and are here to help you drive that change.",
  },
};

const MissionVisionPurposeCIION: React.FC<MissionVisionPurposeCIIONProps> = ({
  id = "mission-vision-purpose",
  title = defaultProps.title,
  mission = defaultProps.mission,
  vision = defaultProps.vision,
  purpose = defaultProps.purpose,
}) => {
  return (
    <section
      id={id}
      className="bg-secondary-100"
      aria-labelledby="mission-vision-purpose-heading"
    >
      <div className="mx-auto grid max-w-lg grid-cols-1 gap-4 p-4 md:gap-6 md:px-6 md:py-8 lg:gap-8 lg:px-3 lg:py-10">
        <h2
          id="mission-vision-purpose-heading"
          className="sr-only"
        >
          {title}
        </h2>
        {[mission, vision, purpose].map((mvp) => (
          <div
            className="flex items-center justify-center"
            key={"mvp-" + mvp.title}
          >
            <div className="flex max-w-5xl flex-col gap-2 md:flex-row md:gap-6 lg:grid lg:grid-cols-5 lg:items-center lg:py-6">
              <h3 className="basis-1/3 whitespace-nowrap font-montserrat text-heading-4 text-neutral-600 md:col-span-2 md:text-heading-3 lg:text-heading-2">
                {mvp.title}
              </h3>
              <p className="body-1-300 lg:body-1-400 basis-2/3 font-roboto text-neutral-600 md:col-span-3 lg:w-[620px] lg:text-neutral-500">
                {mvp.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MissionVisionPurposeCIION;
